import script from "./DocumentCheckPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentCheckPanel.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentCheckPanel.vue?vue&type=style&index=0&id=529eebaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-529eebaa"]])

export default __exports__